import { format, parse } from 'date-fns';
import { isEmpty, isNull, isUndefined } from 'lodash';
import i18n from '../i18n';
import { DATE_FORMAT } from '../constants';
import { getDiffInYearsFromNow } from './dates';
import { attachDefaultCityVillage } from './countryHelper';

export const getUnlockedStepsUpToPayment = (steps) => steps
  .filter((step) => step.n < steps.length)
  .map((s) => s.id);

export const getCoveragesNames = (coverages, fieldNames) => {
  const coverageNames = coverages.reduce(
    (acc, currentValue) => [...acc, currentValue[fieldNames[i18n.language]]],
    [],
  );

  return coverageNames.length ? coverageNames.join(', ') : '-';
};

export const isDisablePaymentFrequencyOption = (step, targetStep) => (
  step ? step.id === targetStep : false
);

export const setSignerInitialData = (user, ekengUser, signer, setInitialData, setIsFormVisible) => {
  let newInitialData = {};
  let shouldShowForm = false;
  if (!isEmpty(user)) {
    shouldShowForm = true;
    newInitialData = user;
  }
  if (!isEmpty(signer)) {
    shouldShowForm = true;
    newInitialData = signer;
  }
  if (!isEmpty(ekengUser)) {
    shouldShowForm = true;
    newInitialData = ekengUser;
  }
  setInitialData(newInitialData);
  if (shouldShowForm) {
    setIsFormVisible(true);
  }
};

export const parseUserDateValues = (user, dateFormat) => {
  const { birthday, passportGiven, passportValidUntil } = user;
  return {
    ...user,
    birthday: birthday && parse(birthday, dateFormat, new Date()),
    passportGiven:
        passportGiven && parse(passportGiven, dateFormat, new Date()),
    passportValidUntil:
        passportValidUntil && parse(passportValidUntil, dateFormat, new Date()),
  };
};

export const formatUserDateValues = (user, dateFormat) => {
  const { birthday, passportGiven, passportValidUntil } = user;
  return {
    ...user,
    birthday: birthday && format(birthday, dateFormat),
    age: getDiffInYearsFromNow(birthday),
    passportGiven: passportGiven && format(passportGiven, dateFormat),
    passportValidUntil: passportValidUntil && format(passportValidUntil, dateFormat),
  };
};

export const separateUserContactInfo = (user) => {
  const {
    phone,
    cellPhone,
    email,
    street,
    streetEn,
    country,
    state,
    cityVillage,
    ...rest
  } = user;
  return {
    ...rest,
    contactInfo: {
      phone,
      cellPhone,
      email,
      street,
      streetEn: streetEn ?? '',
      country,
      state,
      cityVillage,
    },
  };
};

export const mergeUserContactInfo = (user) => {
  const { contactInfo, ...rest } = user;
  return {
    ...rest,
    ...contactInfo,
    // avoid null values for phone and cellphone
    phone: contactInfo.phone || '',
    cellPhone: contactInfo.cellPhone || '',
  };
};

export const convertUserToApiFormat = (user, dateFormat = DATE_FORMAT) => {
  let convertedUser = { ...user };
  convertedUser = formatUserDateValues(convertedUser, dateFormat);
  convertedUser = separateUserContactInfo(convertedUser);
  return convertedUser;
};

export const convertUserToStoreFormat = (user, dateFormat = DATE_FORMAT) => {
  let convertedUser = user;
  convertedUser = parseUserDateValues(convertedUser, dateFormat);
  convertedUser = mergeUserContactInfo(convertedUser);
  return convertedUser;
};

export const getMembersOtherThanSigner = (
  members,
) => members.filter((member) => member.memberId !== 0);

export const bindMobileContractUserData = (userDetails) => {
  const data = { ...userDetails };
  data.firstNameEn = userDetails.firstNameEN;
  data.lastNameEn = userDetails.lastNameEN;
  data.emailConfirm = userDetails.email;
  data.email = userDetails.email;
  data.cellPhone = `0${userDetails.phone.substring(4).trim()}`;
  data.phone = '';
  if (!isNull(data.buildingNumber) && !isUndefined(data.buildingNumber)) {
    data.street = `${data.street} ${data.buildingNumber}${data.apartment ? ` բն. ${data.apartment}` : ''}`;
  }
  data.streetEn = '-';

  return data;
};

export const getContractMemberItems = (itemName, members, selectedMemberId) => {
  const nonSelectedMembers = members.filter((member) => member.memberId !== selectedMemberId);
  return nonSelectedMembers.reduce((acc, currentMember) => {
    const item = currentMember[itemName];
    if (!isUndefined(item)) {
      acc.push(item);
    }
    return acc;
  }, []);
};

// Here we can add additional methods to parse data and return
export const bindContractMemberData = (data) => attachDefaultCityVillage(data);

export const handleContractSingerAction = (
  dispatch,
  setOrUpdateSigner,
  clearSignerBackendErrors,
  isAuthenticated,
  saveDraftContract,
  data,
) => {
  dispatch(setOrUpdateSigner({ ...data, resident: 1, memberId: 0 }));
  dispatch(clearSignerBackendErrors());
  if (isAuthenticated) {
    dispatch(saveDraftContract());
  }
};
